import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useMemo,
  useRef,
  useState,
} from "react";
import "./style.css";
import { HStack, Text, WarningOutlineIcon } from "native-base";
import { errorMessageIcon } from "../../utils/svg";
import { COLORS } from "../../utils/colors";
import { COMMONFONTSIZE } from "../../utils/fonts";

const isIOS = () => {
  return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
};

const InputField = forwardRef(
  (
    {
      name = "input",
      label = "",
      value = "",
      type = "text",
      width = "auto",
      isInvalid = false,
      isDisabled = false,
      errorMessage = "Enter details",
      placeholder = "",
      onChange = () => { },
      speaker = false,
      important = false,
      forceRemount = false,
      basic_details = false,
      transparent = false,
      ind = 0,
      setEventBreakError = () => { },
    },
    ref
  ) => {
    const inputRef = useRef(null);
    const [show, setShow] = useState(false);
    const formControlKey = useMemo(() => Date.now(), [forceRemount]);
    const [inputValue, setInputValue] = useState({
      value: value !== "" ? value : "",
      name: "",
    });
    const [showError, setShowError] = useState(false);
    const [errorMsg, setErrorMsg] = useState("");

    useEffect(() => {
      if (value === "") setInputValue({ value: "" });
      else setInputValue({ value: value });
    }, [forceRemount]);

    useEffect(() => {
      if (speaker) {
        if (value === "") setInputValue({ value: "" });
        else setInputValue({ value: value });
        setShowError(false);
        setEventBreakError(false);
      }
    }, [forceRemount, value]);

    const handleInputChange = (e, name) => {
      let newValue = e.target.value;

      if (
        (name === "speaker_name" ||
          name === "speaker_designation" ||
          name === "sightseeing") &&
        newValue !== "" &&
        !/^[^<>~"`{}\\]*$/.test(newValue)
      ) {
        setShowError(true);
        setEventBreakError(true);
        let error =
          name === "speaker_name"
            ? "Speaker Name"
            : name === "sightseeing"
              ? "Sightseeing"
              : "Speaker Designation";
        setErrorMsg(`Enter valid ${error}`);
        return;
      } else if (
        (name === "speaker_name" ||
          name === "speaker_designation" ||
          name === "sightseeing") &&
        newValue !== "" &&
        newValue.length > 500
      ) {
        setShowError(true);
        setEventBreakError(true);
        let error =
          name === "speaker_name"
            ? "Speaker Name"
            : name === "sightseeing"
              ? "Sightseeing"
              : "Speaker Designation";
        setErrorMsg(`Enter ${error} less than 500 characters`);
        return;
      }

      // if (
      //   (name === "conference_location" || name === "event_location") &&
      //   newValue !== "" &&
      //   !/^[a-zA-Z0-9:/.?=&@#%+_~,'()-]*$/.test(newValue)
      // )
      //   return;
      // else
      if (
        name !== "conference_location" &&
        name !== "event_location" &&
        name !== "video_notification" &&
        newValue !== "" &&
        !/^[^<>~"`{}\\]*$/.test(newValue)
      ) {
        return;
      }

      if (
        (name === "phone" ||
          name === "phone_2" ||
          name === "phone_3" ||
          name === "estimated_budget" ||
          name === "number_of_persons" ||
          name === "number_of_nights") &&
        newValue !== "" &&
        !/^[0-9]*$/.test(newValue)
      ) {
        return;
      }

      // if (
      //   (name === "boarding_from" || name === "destination_to") &&
      //   // || name === "conference_location" ||
      //   // name === "event_location"
      //   newValue !== "" &&
      //   !/^(?!\s)[A-Za-z!@#$%^&*()\-_=+<>?@\s]*$/.test(newValue)
      // ) {
      //   return;
      // }

      if ((name === "phone" || name === "phone_2" || name === "phone_3") && newValue.length > 10) return;

      if (
        (name === "business" ||
          name === "coordinator_name" ||
          name === "coordinator_name_2" ||
          name === "coordinator_name_3" ||
          // name === "boarding_from" ||
          // name === "destination_to" ||
          name === "event_name" ||
          // name === "conference_location" ||
          name === "document_name" ||
          name === "boarding_from" ||
          name === "destination_to") &&
        newValue !== "" &&
        !/^(?!\s)[A-Za-z0-9!@,#$%^&*()-_+=<>?\s]*$/.test(newValue)
      ) {
        return;
      }
      setShowError(false);
      setEventBreakError(false);
      setInputValue({ value: newValue, name: name });
      onChange(e, name, ind);
    };

    const onSubmitInput = () => {
      return inputValue;
    };

    const handleButtonClick = () => {
      if (inputRef.current) {
        inputRef.current.blur();
      }
    };

    useImperativeHandle(ref, () => ({
      onSubmitInput,
      handleButtonClick,
    }));

    return (
      <div style={{ width: width, marginTop: "4px" }}>
        {label && (
          <div style={{ display: "flex" }}>
            <label className="input-form-label">{label} </label>{" "}
            {important && <span style={{ paddingLeft: "4px" }}> *</span>}
          </div>
        )}
        <div className="input-form-div">
          <input
            key={formControlKey}
            ref={inputRef}
            name={name}
            {...((isIOS() && basic_details) || speaker
              ? {
                defaultValue: inputValue.value,
                onBlur: (e) => handleInputChange(e, name),
              }
              : {
                value: inputValue.value,
                onChange: (e) => handleInputChange(e, name),
              })}
            size="20"
            disabled={isDisabled}
            isDisabled={isDisabled}
            type={type === "password" ? (show ? "text" : "password") : type}
            placeholder={placeholder}
            className={
              isInvalid || showError
                ? "input-form-field invalid-input-form-field"
                : "input-form-field"
            }
            style={{ backgroundColor: transparent && "transparent" }}
          />
          {type === "password" && (
            <button
              onClick={() => setShow(!show)}
              style={{
                position: "absolute",
                top: "50%",
                right: "10px",
                transform: "translateY(-50%)",
                cursor: "pointer",
              }}
            >
              {show ? "Hide Password" : "Show Password"}
            </button>
          )}
        </div>
        {!showError && isInvalid && (
          <HStack space={1} alignItems={"center"} mt={1.5}>
            {/* {errorMessageIcon} */}
            <WarningOutlineIcon size="xs" color="rgb(220, 38, 38)" />
            <Text
              color={COLORS.ERROR_MESSAGE_COLOR}
              fontSize={COMMONFONTSIZE.SMALL_FONT_SIZE}
            >
              {errorMessage}
            </Text>
          </HStack>
        )}
        {showError && (
          <HStack space={1} alignItems={"center"} mt={1.5}>
            {/* {errorMessageIcon} */}
            <WarningOutlineIcon size="xs" color="rgb(220, 38, 38)" />
            <Text
              color={COLORS.ERROR_MESSAGE_COLOR}
              fontSize={COMMONFONTSIZE.SMALL_FONT_SIZE}
            >
              {errorMsg}
            </Text>
          </HStack>
        )}
      </div>
    );
  }
);

export default InputField;

// import {
//   forwardRef,
//   useImperativeHandle,
//   useMemo,
//   useRef,
//   useState,
// } from "react";
// import { Box, Input, FormControl, Pressable } from "native-base";
// import InputErrorMessage from "../inputErrorMessage";
// import Svg from "react-native-svg";
// import { passwordCloseIconSVG, passwordOpenIconSVG } from "../../utils/svg";

// const InputField = forwardRef(
//   (
//     {
//       name = "input",
//       label = "",
//       value = "",
//       defaultValue = "",
//       type = "text",
//       width = "auto",
//       isInvalid = false,
//       isDisabled = false,
//       errorMessage = "Enter details",
//       placeholder = "",
//       onChange = () => {},
//       important = false,
//       // event
//       forceRemount = false,
//     },
//     ref
//   ) => {
//     const inputRef = useRef(null);
//     const [show, setShow] = useState(false);
//     const formControlKey = useMemo(() => Date.now(), [forceRemount]);
//     const [inputValue, setInputValue] = useState({
//       value: value !== "" ? value : "",
//       name: "",
//     });

//     const handleInputChange = (e, name) => {
//       setInputValue({ value: e.target.value, name: name });
//       onChange(e, name)
//     };

//     const onSubmitInput = () => {
//       return inputValue;
//     };

//     // const handleInputChange = (e) => {
//     //   onChange(e, name, e.target.value);
//     // };

//     // const onSubmitInput = () => {
//     //   return { value, name };
//     // };

//     const handleButtonClick = () => {
//       if (inputRef.current) {
//         inputRef.current.blur();
//       }
//     };

//     useImperativeHandle(ref, () => ({
//       onSubmitInput,
//       handleButtonClick,
//     }));

//     return (
//       <Box>
//         <FormControl
//           isInvalid={isInvalid}
//           isDisabled={isDisabled}
//           w={width}
//           key={formControlKey}
//         >
//           {label && (
//             <FormControl.Label>
//               {label} {important && <span> *</span>}
//             </FormControl.Label>
//           )}
//           <Input
//             ref={inputRef}
//             name={name}
//             defaultValue={inputValue.value}
//             // defaultValue={value}
//             onChange={(e) => handleInputChange(e, name)}
//             // defaultValue={value}
//             size="20"
//             type={type === "password" ? (show ? "text" : "password") : type}
//             placeholder={placeholder}
//             // onBlur={(e) => onChange(e, name)}
//             style={{ fontSize: "14", height: "36px" }}
//             InputRightElement={
//               type === "password" && (
//                 <Pressable onPress={() => setShow(!show)} pr={3}>
//                   {show ? (
//                     <Svg width="24" height="24" viewBox="0 0 24 24">
//                       {passwordOpenIconSVG}
//                     </Svg>
//                   ) : (
//                     <Svg width="24" height="24" viewBox="0 0 24 24">
//                       {passwordCloseIconSVG}
//                     </Svg>
//                   )}
//                 </Pressable>
//               )
//             }
//           />
//           {isInvalid && <InputErrorMessage errorMessage={errorMessage} />}
//         </FormControl>
//       </Box>
//     );
//   }
// );

// export default InputField;
